// extracted by mini-css-extract-plugin
export var editor = "_14-0";
export var flowSidebar = "_3x-2";